import React, { useState, useEffect } from 'react';
import ButtonPolicy from "src/components/Permission/ButtonPolicy";
import { Grid, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { useAlertContext } from 'src/hooks/use-alert';
import 'src/components/NoteBook/notebook.css';
import BudgetDataGridComponent from 'src/components/DataGrid/BudgetDataGrid';
import { CSVLink } from 'react-csv';
import Image from 'mui-image';
import csv from 'src/img/csv.png';
import pdf from 'src/img/pdf.png';
import "src/pages/Deals/Deals.css";

const MntCompanyDetail = ({mntCompany}) => {
  const alert = useAlertContext();  
  const [operators, setOperators] = useState([]);
  const [csvData,setCsvData]=useState([])     /**   Csv file data container **/

  const columns = [
    { field: 'Name', headerName: 'Name', flex: 1 },
    { field: 'Surname', headerName: 'Surname', flex: 1 },
    { field: 'Email', headerName: 'Email', flex: 1 }
    ];


  // const handleNewOperator = () => {
  //   setOpenDealForm(true)
  // };


  useEffect(() => {

    if (mntCompany.mntOperators && mntCompany.mntOperators.length > 0) {
     // let id = 0;
      const operators = mntCompany.mntOperators.map((operator) => {
          return { id: operator.id, Name: operator.name, Surname: operator.surname, Email: operator.email};
      });
      setOperators(operators);
    }
  }, [mntCompany]);

  /**UseEffect for prepping CsvData */
  useEffect(()=>{
    if(mntCompany){
      const data = mntCompany.mntOperators.map((row) => ({
        Name: row.name, Surname: row.surname, Email: row.Email}));
     setCsvData(data);
  
    }
  
  },[mntCompany])
  




  return (
    <div className='notebookContainer'>
      <h2 className='DealsHeader'>{mntCompany.name}</h2>
      <Grid container>
        
      <div className='NoteDescription'> 
      phoneNumber : {mntCompany.phoneNumber} <br></br>
      Email: {mntCompany.email}<br></br>
      Address: {mntCompany.address} 
      </div>
                      
      <div  style = {{ width : 850, marginTop : 20 }}>
        <h3> Operators : </h3>
        <div className='datagrid-container'>
             {operators.length > 0 ? (
          <div className='DealsDatagrid'>
        <BudgetDataGridComponent rows={operators} columns={columns}   />
      
        {/* Bottom right div */}
        <div className='bottom-container'>
        <Grid item md={3} lg={3} sm={6} xs={12}>
          <div className='cardHolder'>
            
          </div>
        </Grid>
          {/*csv image button */}
          <CSVLink className='csvImageHolder' data={csvData} headers={columns.map((column) => ({
            label: column.headerName,
            key: column.field,
          }))}>
            
              <Image src={csv} />
            
          </CSVLink>
          {/*pdf image button */}
          <div className='csvImageHolder'>
            <Image src={pdf} />
          </div>
        </div>
        </div>): (
                 <div className='condtionalInfo'> <h2>There aren't any operators yet, Please add some !</h2></div>
            )}
      </div>
      </div>
      </Grid>
    </div>
  );
};

export default MntCompanyDetail;
